/* Sleep LP — How to use video playback
   Inline tiles show the poster image / muted preview. Clicking the play
   button opens a modal and plays the full video with sound. */
(function () {
  'use strict';

  function initSection(root) {
    var modal = root.querySelector('[data-ht-modal]');
    var modalVideo = root.querySelector('[data-ht-modal-video]');
    var closers = root.querySelectorAll('[data-ht-close]');

    function open(html, src) {
      if (!modal || !modalVideo) return;
      modalVideo.innerHTML = '';
      if (html) {
        modalVideo.innerHTML = html;
        var v = modalVideo.querySelector('video');
        if (v) { v.muted = false; v.controls = true; v.play().catch(function () {}); }
      } else if (src) {
        var video = document.createElement('video');
        video.src = src;
        video.controls = true;
        video.autoplay = true;
        video.muted = false;
        video.playsInline = true;
        modalVideo.appendChild(video);
      }
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      if (!modal || !modalVideo) return;
      modal.hidden = true;
      modalVideo.innerHTML = '';
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-ht-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.ht-use__video');
        var cards = root.querySelectorAll('.ht-use__video');
        var index = Array.prototype.indexOf.call(cards, card);
        var template = root.querySelector('[data-ht-full="' + index + '"]');
        var html = template ? template.innerHTML : '';
        var src = btn.dataset.fullSrc || '';
        open(html, src);
      });
    });

    closers.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) close();
    });

    var firstCard = root.querySelector('.ht-use__video');
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    if (isMobile && firstCard && 'IntersectionObserver' in window) {
      var firstVideo = firstCard.querySelector('video');
      if (firstVideo) {
        firstVideo.muted = true;
        firstVideo.playsInline = true;
        firstVideo.setAttribute('playsinline', '');
        firstVideo.loop = true;
        if (firstVideo.preload === 'none') firstVideo.preload = 'metadata';
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              firstVideo.play().catch(function () {});
            } else {
              firstVideo.pause();
            }
          });
        }, { threshold: 0.5 });
        io.observe(firstCard);
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-how-to-use]').forEach(initSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll && e.target.querySelectorAll('[data-how-to-use]').forEach(initSection);
  });
})();
